<template>
    <div>
        <div id="label">Sign-in with Microsoft Azure AD B2C</div>

        <button @click="login" v-if="!user">Login</button>
        <button @click="logout" v-if="user">Logout</button>
        <button @click="ping">Call API Ping</button>

        <div v-if="user">Hello from Vue.js. User is {{user.name}}</div>

        <!-- <vueSelect
            :filter="filter"
            placeholder="original vue-select"
            :options="[{label: 'Canada', code: 'ca'}]"
        ></vueSelect>

        <vSelect
            placeholder="Vores egen"
            :dynamicWidth="true"
            :filter="filter"
            :options="[{label: 'Canada', code: 'ca'}]"
        ></vSelect>

        <vSelect
            :options="[{label: 'Canada', code: 'ca'}]"
            placeholder="Ny Test Wrapper 2"
        ></vSelect>-->
    </div>
</template>

<script>
  import { ACTIONS, CORE_PREFIX } from '../store/constants';
  import vueSelect from 'vue-select';
  import 'vue-select/dist/vue-select.css';

  import vSelect from '../components/vSelect';

  export default {
      name: 'HelloWorld',

      components: {
          vueSelect,
          vSelect,
      },

      mounted() {
          this.$store.dispatch(CORE_PREFIX + ACTIONS.CORE.SET_LOADING, false);
      },
      methods: {
          login() {
              this.$AuthService.login();
          },
          logout() {
              this.$AuthService.logout();
          },
          ping() {
              var token = this.$AuthService.acquireTokenSilent();
          },
          filter(options, search) {},
      },
      computed: {
          user: function () {
              return this.$AuthService.getUser();
          },
      },
  };
</script>